import { userLink } from './user-link';

export const foreignRecords = $axios => ({
  get: (viewId, { fieldId, recordId }) => $axios.$get(`/views/${viewId}/fields/${fieldId}/links`, {
    params: { record_id: recordId },
  }),
  userLink: userLink($axios),
});
